<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist
			@help="help"
			@add="add"
			@search="search"
			@reflash="reflash"
			@del="delall"
			ref="SetBtn"
		></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			header-row-class-name="headerclass"
			:height="tableHeight"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
			ref="singleTable"
		>
			<el-table-column  type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="commodity_type_CODE" :label="$t('getapi[3348]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="commodity_type_NAME" :label="$t('getapi[3349]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="REMARK" :label="$t('getapi[143]')" width="80"></el-table-column>
			<el-table-column prop="stuff_flag" :label="$t('getapi[6875]')" width="80">
				<template scope="scope">
					<el-checkbox v-model="scope.row.stuff_flag" :true-label=true :false-label=false :disabled="true">
					</el-checkbox>
				</template>
			</el-table-column>
			<el-table-column prop="check_flag" :label="$t('getapi[6876]')" width="80">
				<template scope="scope">
					<el-checkbox v-model="scope.row.check_flag" :true-label=true :false-label=false :disabled="true">
					</el-checkbox>
				</template>
			</el-table-column>
			<el-table-column prop="coc_flag" :label="$t('getapi[6877]')" width="80">
				<template scope="scope">
					<el-checkbox v-model="scope.row.coc_flag" :true-label=true :false-label=false :disabled="true">
					</el-checkbox>
				</template>
			</el-table-column>
			<el-table-column prop="salt_flag" :label="$t('getapi[6878]')" width="80">
				<template scope="scope">
					<el-checkbox v-model="scope.row.salt_flag" :true-label=true :false-label=false :disabled="true">
					</el-checkbox>
				</template>
			</el-table-column>
			<el-table-column prop="examine_flag" :label="$t('getapi[6879]')" width="80">
				<template scope="scope">
					<el-checkbox v-model="scope.row.examine_flag" :true-label=true :false-label=false :disabled="true">
					</el-checkbox>
				</template>
			</el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="edit(scope)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
						:confirmButtonText="$t('getapi[6109]')"
						:cancelButtonText="$t('getapi[6]')"
						icon="el-icon-info"
						iconColor="red"
						:title="$t('getapi[637]')"
						@onConfirm="del(scope)"
					>
						<el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<!--<el-col :span="12">
				<el-pagination
					style="margin-top: 1em"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="50"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">-->
				<div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			<!--</el-col>-->
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%" :close-on-click-modal="false">
			<el-tabs type="border-card">
				<el-tab-pane :label="$t('getapi[2020]')">
					<el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
						<el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
						<el-table-column :label="$t('getapi[2022]')">
							<template slot-scope="scope">
								<input type="text" v-model="scope.row.query_Condition" style="border:none" />
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
			</el-tabs>

			<span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
			
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3348]')}}</td>
					<td><el-input v-model="formInline._commodity_type_code" type="text" size="mini" ></el-input></td>
					<td>{{$t('getapi[3349]')}}</td>
					<td><el-input v-model="formInline._commodity_type_name" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="formInline._remark" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[6875]')}}</td>
					<td>
						<el-checkbox v-model="formInline._stuff_flag" :true-label=true :false-label=false></el-checkbox>
					</td>
					<td>{{$t('getapi[6876]')}}</td>
					<td>
						<el-checkbox v-model="formInline._check_flag" :true-label=true :false-label=false></el-checkbox>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[6877]')}}</td>
					<td>
						<el-checkbox v-model="formInline._coc_flag" :true-label=true :false-label=false></el-checkbox>
					</td>
					<td>{{$t('getapi[6878]')}}</td>
					<td>
						<el-checkbox v-model="formInline._salt_flag" :true-label=true :false-label=false></el-checkbox>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[6879]')}}</td>
					<td>
						<el-checkbox v-model="formInline._examine_flag" :true-label=true :false-label=false></el-checkbox>
					</td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name: 'itemcommondittype',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			formInline: {
				_exclusively_id: 0,
				_commodity_type_code: '',
				_commodity_type_name: '',
				_remark: ''
			},
			ids: '',
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: 50,
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataSetDetail: {}, // 编辑页面数据详情
			queryData: [], // 查询数组
			selectIDData: '', // 选择的数据的ID集合
			tracetype: 0, //跟踪类别
			url: '', // 零件图路径
			isEdit: true ,// 是否新增
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		//this.getqwlist();
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		console.log('mounted');
		let that = this;
		that.intidata();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1090]"),this.$t("getapi[11]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.ReadOnlyRights('plv2', 26, 1)) {
				that.$refs.SetBtn.SetButtonEnable('search,refresh');
			}
			//操作权
			let ilimits = that.$limits.UnOperationAuthority('plv2', 26, 1);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (ilimits) {
				case 2:
				that.btn.edit = true;
				that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh');
					break;
				case 3:
				that.btn.edit = true;
				that.btn.del = true;
					that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh');
					break;
				default:
					that.$refs.SetBtn.SetButtonEnable('');
					break;
			}
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			/*let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: []
			};
			that.queryData.forEach(item => {
				//if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						query_Condition: item.query_Condition,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
				//}
			});
			console.log(parm);*/
			that.$http.urlpost('Basic/Items/GetPartCommodityTypeList', '', function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					/*that.total = res.Totals;*/
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},
		// 保存数据
		sava() {
			let that = this;
			that.loading = true;
			let parm = new Array();
			parm.push(that.formInline);
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Basic/Items/SavePartCommodityType', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[284]'));
                    that.editvisi = false;
					that.intidata();
				}
				that.loading = false;
			});
		},
		// 获取查询条件
		getqwlist() {
			let that = this;
			that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
				that.queryData = res.DataContent;
			});
		},
		// 编辑
		edit(jsd) {
			console.log(jsd);
			this.editvisi = true;
			this.formInline = {
				_exclusively_id: jsd.row.Exclusively_Id,
				_commodity_type_code: jsd.row.commodity_type_CODE,
				_commodity_type_name: jsd.row.commodity_type_NAME,
				_remark: jsd.row.REMARK,
                _stuff_flag: jsd.row.stuff_flag,
                _check_flag: jsd.row.check_flag,
                _coc_flag: jsd.row.coc_flag,
                _salt_flag: jsd.row.salt_flag,
                _examine_flag: jsd.row.examine_flag
			};
			console.log(this.formInline);
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},
		// 删除
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('Basic/Items/DeletePartCommodityTypeByID', parm, function(res) {
				that.intidata();
				that.$message.success(that.$t('getapi[659]'));
			});
		},
		// 删除
		del(jsd) {
			this.ids = jsd.row.Exclusively_Id + ',';
			this.delf();
		},
		//批量删除
		delall() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
			this.formInline = {
				_exclusively_id: 0,
				_commodity_type_code: '',
				_commodity_type_name: '',
				_remark: '',
                _stuff_flag: false,
                _check_flag: false,
                _coc_flag: false,
                _salt_flag: false,
                _examine_flag: false
			};
			this.editvisi = true;
		},
		// 查询
		search() {
			this.isVisible = true;
		},
		// 刷新
		reflash() {
			this.intidata();
		}
		//导出·
		// exp() {
		// 	let that = this;
		// 	that.showloading = that.openLoading();
		// 	let pm = {
		// 		query_Condition: '',
		// 		query_field_type: '',
		// 		query_field_name: ''
		// 	};
		// 	let parm = {
		// 		PageIndex: that.PageIndex,
		// 		PageSize: that.PageSize,
		// 		SelectIndex: that.SelectIndex,
		// 		Ids: that.selectIDData,
		// 		Param: []
		// 	};
		// 	that.queryData.forEach(item => {
		// 		if(item.query_Condition==''||item.query_Condition.length>0) {
		// 			pm = {
		// 				query_Condition: item.query_Condition,
		// 				query_field_type: item.Query_Field_Type,
		// 				query_field_name: item.Query_Field_Name
		// 			};
		// 			parm.Param.push(pm);
		// 		}
		// 	});
		// 	console.log(parm);
		// 	that.$http.urlpost('Basic/Items/WorkCenter_ExportToExecl', parm, function(res) {
		// 		if (res.Success == 1) {
		// 			let hrefurl = Common.Url + res.DataContent.URL;
		// 			window.open(hrefurl);
		// 		} else {
		// 			that.$message.error(res.Msg);
		// 		}
		// 		that.showloading.close();
		// 	});
		// }
	}
};
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
